import { get } from "lodash";
import customAxios from "../serverCall";

// const AuthService = () => {
const Login = async (loginPage) => {
  const response = await customAxios.post(`/admin/auth/login`, loginPage);

  const data = response.data.data;

  if (data) {
    const socialStorage = {
      token: data.token,
      email: data?.user?.email,
      username: data?.user?.username,
      isLoggedIn: true,
    };
    localStorage.setItem("social-storage", JSON.stringify(socialStorage));
  }
  return response;
};

const AuthService = {
  Login,
};

export default AuthService;
